module.exports = __webpack_public_path__ + "img/couples-049.2c7b9da7.jpg";